(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-quantity-discount"] && !Shopify.designMode) return;
  try {
    class BundleQuantityDiscount extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleChange);
      document.addEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);

      this.productId = this.dataset.productId;
      this.productGid = this.productId ? `gid://shopify/Product/${this.productId}` : '';

      const checked = this.querySelector('.bundle-tier__radio:checked');
      if (checked) this.applyQuantity(checked.value);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      document.removeEventListener('shopify:cart:lines-update', this.handleCartLinesUpdate);
    }

    handleChange = (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
      this.applyQuantity(target.value);
    };

    applyQuantity(value) {
      const quantity = parseInt(value, 10) || 1;
      const scope = this.closest('[id^="ProductInformation-"]') || document;
      const quantitySelector = scope.querySelector('quantity-selector-component');
      const productForm = scope.querySelector('product-form-component');

      if (quantitySelector && typeof quantitySelector.setValue === 'function') {
        quantitySelector.setValue(String(quantity));
        if (typeof quantitySelector.updateButtonStates === 'function') {
          quantitySelector.updateButtonStates();
        }
        if (typeof quantitySelector.onQuantityChange === 'function') {
          quantitySelector.onQuantityChange();
        }
      }

      if (productForm) {
        productForm.dataset.quantityDefault = String(quantity);
      }
    }

    // Detecta cuando ESTE producto se añade al carrito con una cantidad que
    // coincide con un tramo que tiene regalo configurado, y añade ese regalo
    // con una segunda llamada al carrito. También escucha los cambios hechos
    // DESDE el propio carrito (subir/bajar cantidad, eliminar la línea): si
    // la cantidad de este producto deja de alcanzar cualquier tramo con
    // regalo, retira el regalo correspondiente.
    handleCartLinesUpdate = (event) => {
      if (event.syntheticSource === 'gift-sync') return; // evita bucles con nuestros propios eventos

      if (event.context === 'product' && event.action === 'add') {
        this.handleProductAdd(event);
      } else if (event.context === 'cart' && (event.action === 'update' || event.action === 'remove')) {
        this.handleCartChange(event);
      }
    };

    handleProductAdd(event) {
      if (!Array.isArray(event.lines) || event.lines.length === 0) return;

      // Un formulario de producto sólo puede añadir variantes de SU PROPIO
      // producto -- para saber si este evento viene de nuestra propia ficha
      // (y no de un quick-add de otro producto en "También te puede
      // interesar"), comprobamos que el elemento que disparó el evento esté
      // dentro del mismo bloque de información de producto que este selector.
      const scope = this.closest('[id^="ProductInformation-"]');
      if (scope && event.target instanceof Node && !scope.contains(event.target)) return;

      const addedLine = event.lines[0];
      const tier = this.querySelector(`.bundle-tier[data-quantity="${addedLine.quantity}"][data-gift-variant-id]`);
      if (!tier) return;

      const giftVariantId = tier.dataset.giftVariantId;
      if (!giftVariantId) return;

      this.addGiftToCart(giftVariantId);
    }

    async handleCartChange(event) {
      if (!event.promise || !this.productId) return;

      let resolved;
      try {
        resolved = await event.promise;
      } catch {
        return;
      }

      const items = resolved?.detail?.items;
      if (!Array.isArray(items)) return;

      const myQuantity = items
        .filter((item) => String(item.product_id) === this.productId)
        .reduce((sum, item) => sum + item.quantity, 0);

      const stillQualifies = !!this.querySelector(
        `.bundle-tier[data-quantity="${myQuantity}"][data-gift-variant-id]`
      );
      if (stillQualifies) return;

      const giftItem = items.find((item) => item.properties && item.properties['_regalo_de'] === this.productGid);
      if (!giftItem) return;

      this.removeGiftFromCart(giftItem.key);
    }

    async addGiftToCart(giftVariantId) {
      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: giftVariantId,
            quantity: 1,
            properties: { _regalo: 'Sí', _regalo_de: this.productGid },
          }),
        });

        if (!response.ok) return;

        this.dispatchGiftSyncEvent('add', [{ merchandiseId: giftVariantId, quantity: 1 }]);
      } catch (error) {
        console.error('No se pudo añadir el regalo al carrito', error);
      }
    }

    async removeGiftFromCart(giftLineKey) {
      try {
        const response = await fetch(Theme.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftLineKey, quantity: 0 }),
        });

        if (!response.ok) return;

        this.dispatchGiftSyncEvent('remove', [{ id: giftLineKey, quantity: 0 }]);
      } catch (error) {
        console.error('No se pudo retirar el regalo del carrito', error);
      }
    }

    dispatchGiftSyncEvent(action, lines) {
      const syntheticEvent = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      syntheticEvent.action = action;
      syntheticEvent.context = 'cart';
      syntheticEvent.lines = lines;
      syntheticEvent.promise = Promise.resolve({ detail: {} });
      syntheticEvent.syntheticSource = 'gift-sync';
      document.dispatchEvent(syntheticEvent);
    }
  }

  if (!customElements.get('bundle-quantity-discount')) {
    customElements.define('bundle-quantity-discount', BundleQuantityDiscount);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-slider"] && !Shopify.designMode) return;
  try {
    class ReviewSliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rs-slides');
      this.dotsWrap = this.querySelector('.rs-dots');
      this.pos = 0;
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    get total() {
      return this.track ? this.track.querySelectorAll('.rs-review').length : 0;
    }

    handleClick = (event) => {
      const arrow = event.target.closest('.rs-arrow');
      const dot = event.target.closest('.rs-dot');

      if (arrow) {
        const dir = parseInt(arrow.dataset.dir, 10);
        this.pos = (this.pos + dir + this.total) % this.total;
        this.render();
      } else if (dot) {
        this.pos = parseInt(dot.dataset.index, 10);
        this.render();
      }
    };

    render() {
      if (!this.track || this.total === 0) return;

      this.track.style.transform = `translateX(-${this.pos * 100}%)`;
      this.dotsWrap?.querySelectorAll('.rs-dot').forEach((dot, index) => {
        dot.classList.toggle('active', index === this.pos);
      });
    }
  }

  if (!customElements.get('review-slider-component')) {
    customElements.define('review-slider-component', ReviewSliderComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
